import {
  CreateExperienceProductTargetingDto,
  CreateExperienceProductTargetingFeDto,
  ProductExpressionPayload,
  ProductTargetingType,
} from "@intelligems/ig-types";
import { postfixToExpressionList } from "@intelligems/ig-utils";
import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import { getExperienceProductTargeting } from "@src/store/slices/experienceProductTargeting/index";

export const getProductTargetingType =
  () =>
  (state: RootState): ProductTargetingType => {
    const experienceProductTargeting: CreateExperienceProductTargetingFeDto[] =
      getExperienceProductTargeting(state);
    if (experienceProductTargeting.length === 0) return "productPage";

    return experienceProductTargeting[0].target;
  };

export const getProductTargetingExpressionList = createSelector(
  getExperienceProductTargeting,
  (productTargeting): ProductExpressionPayload[] => {
    if (productTargeting.length && productTargeting[0].expression) {
      return postfixToExpressionList(
        productTargeting[0].expression,
        "experienceProductTargeting"
      ) as ProductExpressionPayload[];
    }
    return [];
  }
);

/**
 * Selector that returns experienceProductTargeting with displayData stripped.
 * Used for payload serialization to backend.
 */
export const getExperienceProductTargetingForPayload = createSelector(
  getExperienceProductTargeting,
  (productTargeting): CreateExperienceProductTargetingFeDto[] => {
    if (!productTargeting.length) return [];

    // Strip displayData from each targeting entry
    return productTargeting.map((targeting) => {
      if (!targeting.expression) {
        return targeting;
      }

      // Strip displayData from each expression node's query
      const cleanedExpression = targeting.expression.map((node) => {
        if (!node.query) return node;

        // Create a copy without displayData
        const { displayData, ...cleanQuery } = node.query;

        let finalValue = cleanQuery.value;
        if (
          (cleanQuery.type === "price" || cleanQuery.type === "inventory") &&
          typeof cleanQuery.value === "string" &&
          cleanQuery.value !== ""
        ) {
          finalValue =
            cleanQuery.type === "price"
              ? parseFloat(cleanQuery.value)
              : parseInt(cleanQuery.value, 10);
        }

        return {
          ...node,
          query: {
            ...cleanQuery,
            value: finalValue,
          },
        };
      });

      return {
        ...targeting,
        expression: cleanedExpression,
      } as CreateExperienceProductTargetingFeDto;
    });
  }
);
